const FALLBACK_API_BASE = 'http://localhost:8000'
const FALLBACK_SITE_URL = 'http://localhost:5173'

function normalizeApiBase(value?: string): string {
  const base = (value || FALLBACK_API_BASE).trim().replace(/\/+$/, '')
  return base.replace(/\/api\/v1$/, '')
}

function normalizeUrl(value?: string, fallback?: string): string {
  return (value || fallback || '').trim().replace(/\/+$/, '')
}

export const API_BASE = normalizeApiBase(
  (import.meta.env.VITE_API_BASE as string | undefined) ||
    (import.meta.env.VITE_API_URL as string | undefined),
)

export const SITE_URL = normalizeUrl(
  import.meta.env.VITE_SITE_URL as string | undefined,
  FALLBACK_SITE_URL,
)

export const GOOGLE_REDIRECT_URI =
  (import.meta.env.VITE_GOOGLE_REDIRECT_URI as string | undefined) ||
  `${window.location.origin}/auth/callback/google`

export const TERMS_URL =
  (import.meta.env.VITE_TERMS_URL as string | undefined) ||
  `${SITE_URL}/terms`

export const PRIVACY_URL =
  (import.meta.env.VITE_PRIVACY_URL as string | undefined) ||
  `${SITE_URL}/privacy`

export const CHROME_EXTENSION_URL =
  (import.meta.env.VITE_CHROME_EXTENSION_URL as string | undefined) ||
  'https://chromewebstore.google.com/detail/acckhdkkdmjjplgehdhcioabdnckipca'

function extractChromeExtensionId(value?: string): string | null {
  // The id is the trailing path segment of the store URL; take the LAST 32-char
  // [a-p] run so a slug that happens to contain such a run cannot shadow it.
  const matches = (value || '').match(/[a-p]{32}/g)
  return matches && matches.length ? matches[matches.length - 1] : null
}

// Extension IDs allowed to receive an auth handoff. Defaults to the published
// store build (derived from CHROME_EXTENSION_URL); VITE_OFFICIAL_EXTENSION_IDS
// (comma-separated) adds unpacked/dev builds. If none resolve, the allowlist is
// empty and callers fall back to a format-only check.
export const OFFICIAL_EXTENSION_IDS: readonly string[] = (() => {
  const ids = new Set<string>()
  const fromStore = extractChromeExtensionId(CHROME_EXTENSION_URL)
  if (fromStore) ids.add(fromStore)
  const configured = (import.meta.env.VITE_OFFICIAL_EXTENSION_IDS as string | undefined) || ''
  for (const raw of configured.split(',')) {
    const id = raw.trim()
    if (id) ids.add(id)
  }
  return Array.from(ids)
})()

export function chromeExtensionUrl(campaign: string) {
  const url = new URL(CHROME_EXTENSION_URL)
  url.searchParams.set('utm_source', 'mphelper_dashboard')
  url.searchParams.set('utm_medium', 'app')
  url.searchParams.set('utm_campaign', campaign)
  return url.toString()
}
